"use client";
import { Chip as DigDirChip } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const ChipRadio = React.forwardRef(({ className, hero, "data-color": dataColor, "data-size": dataSize, ...props }, ref) => {
    return (React.createElement(DigDirChip.Radio, { ref: ref, className: cn("in-chip__radio", hero && "in-chip-hero", className), "data-size": hero ? "lg" : dataSize, "data-color": hero ? "primary" : dataColor, ...props }));
});
ChipRadio.displayName = "ChipRadio";
export { ChipRadio };
//# sourceMappingURL=chipRadio.js.map